module.exports = __webpack_public_path__ + "static/img/sad200-install.76bd5f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/support/sad200-install.png
// module id = t5jM
// module chunks = 0